import React, { Component } from 'react';
import { translate } from 'react-translate';
import localePT from 'date-fns/locale/pt';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import dayjs from 'dayjs';
import { isEqual } from 'lodash';
import ReactResizeDetector from 'react-resize-detector';
import { DateRangePicker } from 'react-date-range';
import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file
import * as S from './styles';

const defineds = {
  startOfToday: dayjs().startOf('day').format('YYYY-MM-DD'),
  endOfToday: dayjs().endOf('day').format('YYYY-MM-DD'),
  startOfYesterday: dayjs().startOf('day').subtract(1, 'day').format('YYYY-MM-DD'),
  endOfYesterday: dayjs().endOf('day').subtract(1, 'day').format('YYYY-MM-DD'),
  startOfWeek: dayjs().startOf('day').subtract(6, 'day').format('YYYY-MM-DD'),
  startOfMonth: dayjs().startOf('month').format('YYYY-MM-DD'),
  startOfYear: dayjs().startOf('year').format('YYYY-MM-DD'),
  startOfLastMonth: dayjs().startOf('month').subtract(1, 'month').format('YYYY-MM-DD'),
  endOfLastMonth: dayjs().endOf('month').subtract(1, 'month').format('YYYY-MM-DD'),
};

const staticRangeHandler = {
  range: {},
  isSelected(range) {
    const definedRange = this.range();
    return (
      dayjs(range.startDate).isSame(definedRange.startDate, 'day') &&
      dayjs(range.endDate).isSame(definedRange.endDate, 'day')
    );
  },
};

class CustomDateRange extends Component {
  state = {
    selectionRange: {},
    locale: localePT,
    countMonth: 1,
    sizeScreen: '',
  };

  componentDidMount() {
    const {
      props: {
        genericReducer: { period },
      },
    } = this;

    document.addEventListener('keyup', this.checkKeyUp);
    this.updateSelectionRange(period);
  }

  componentWillUnmount() {
    document.removeEventListener('keyup', this.checkKeyUp);
  }

  checkKeyUp = (e) => {
    const {
      props: { closeModal, saveDateRange },
    } = this;
    if (e.keyCode === 27) closeModal();
    if (e.keyCode === 13) saveDateRange();
  };

  createStaticRanges(ranges) {
    return ranges.map((range) => ({ ...staticRangeHandler, ...range }));
  }

  componentDidUpdate(prevProps) {
    const {
      props: {
        genericReducer: { period },
      },
    } = this;

    if (!isEqual(prevProps.genericReducer.period, period)) {
      this.updateSelectionRange(period);
    }
  }

  updateSelectionRange = (period) => {
    const {
      props: { location },
    } = this;

    const params = new URLSearchParams(location.search);
    const datePreset = params.get('date_preset');

    this.setState({
      selectionRange: {
        startDate: new Date(
          new Date(period.start).setDate(
            new Date(period.start).getDate() + (datePreset === 'last_7d' ? 0 : 1)
          )
        ),
        endDate: new Date(
          new Date(period.end).setDate(
            new Date(period.end).getDate() + (datePreset === 'last_7d' ? 0 : 1)
          )
        ),
        key: 'selection',
      },
    });
  };

  setStaticInputRanges = () => {
    const {
      state,
      props: { t },
    } = this;

    let defaultInputRanges;

    if (state.sizeScreen === 'small') {
      defaultInputRanges = [];
    } else {
      defaultInputRanges = [
        {
          label: t('DAYS-UP-TO-TODAY'),
          range(value) {
            const TODAY = new Date(defineds.startOfToday);
            return {
              startDate: dayjs(TODAY).add((Math.max(Number(value), 1) - 1) * -1),
              endDate: defineds.endOfToday,
            };
          },
          getCurrentValue(range) {
            if (dayjs(new Date(range.endDate)).isSame(new Date(defineds.endOfToday + 1), 'day')) return '-';
            if (!range.startDate) return '∞';

            return (
              dayjs(new Date(defineds.endOfToday)).diff(new Date(range.startDate), 'day') + 1
            );
          },
        },
      ];
    }
    return defaultInputRanges;
  };

  setStaticRanges = () => {
    const {
      state,
      props: {
        t,
        genericReducer: { current, currentItem },
      },
    } = this;
    let defaultStaticRanges;
    let startCustom;
    let endCustom;

    if (
      !!current &&
      !!current.data &&
      !!current.data.total &&
      current.data.start_date &&
      current.data.end_date
    ) {
      startCustom = dayjs(current.data.start_date).toDate();
      endCustom = dayjs(current.data.end_date).toDate();
    } else if (
      !!currentItem &&
      !!currentItem.data &&
      !!currentItem.data.start_date &&
      !!currentItem.data.end_date
    ) {
      startCustom = dayjs(currentItem.data.start_date).toDate();
      endCustom = dayjs(currentItem.data.end_date).toDate();
    } else {
      const calcStartDate = new Date();
      calcStartDate.setDate(calcStartDate.getDate() - 85);
      startCustom = dayjs(calcStartDate).toDate();
      endCustom = dayjs().toDate();
    }

    if (state.sizeScreen === 'small') {
      defaultStaticRanges = this.createStaticRanges([]);
    } else {
      defaultStaticRanges = this.createStaticRanges([
        {
          label: t('TODAY'),
          range: () => ({
            startDate: defineds.startOfToday,
            endDate: defineds.endOfToday,
          }),
        },
        {
          label: t('YESTERDAY'),
          range: () => ({
            startDate: defineds.startOfYesterday,
            endDate: defineds.endOfYesterday,
          }),
        },
        {
          label: t('LAST_7D'),
          range: () => ({
            startDate: defineds.startOfWeek,
            endDate: defineds.endOfToday,
          }),
        },
        {
          label: t('LAST_MONTH'),
          range: () => ({
            startDate: defineds.startOfLastMonth,
            endDate: defineds.endOfLastMonth,
          }),
        },
        {
          label: t('THIS_MONTH'),
          range: () => ({
            startDate: defineds.startOfMonth,
            endDate: defineds.endOfToday,
          }),
        },
        {
          label: t('THIS_YEAR'),
          range: () => ({
            startDate: defineds.startOfYear,
            endDate: defineds.endOfToday,
          }),
        },
        {
          label: t('CUSTOM_PERIOD'),
          range: () => ({
            isCustomOption: true,
            startDate: startCustom,
            endDate: endCustom,
          }),
        },
      ]);
    }

    return defaultStaticRanges;
  };

  handleSelect = (ranges) => {
    const {
      state,
      props: {
        handleSelectButtonCalendar,
        saveDateRange,
        genericReducer: { current, currentItem },
      },
    } = this;
    let startCustom;
    let endCustom;

    if (
      !!current &&
      !!current.data &&
      !!current.data.total &&
      current.data.start_date &&
      current.data.end_date
    ) {
      startCustom = dayjs(current.data.start_date).format('YYYY-MM-DD');
      endCustom = dayjs(current.data.end_date).format('YYYY-MM-DD');
    } else if (
      !!currentItem &&
      !!currentItem.data &&
      !!currentItem.data.start_date &&
      !!currentItem.data.end_date
    ) {
      startCustom = dayjs(currentItem.data.start_date).format('YYYY-MM-DD');
      endCustom = dayjs(currentItem.data.end_date).format('YYYY-MM-DD');
    } else {
      const calcStartDate = new Date();
      calcStartDate.setDate(calcStartDate.getDate() - 85);
      startCustom = dayjs(calcStartDate).format('YYYY-MM-DD');
      endCustom = dayjs().format('YYYY-MM-DD');
    }

    if (ranges && ranges.selection) {
      const startSelectionDate = dayjs(ranges.selection.startDate).format('YYYY-MM-DD');
      const endSelectionDate = dayjs(ranges.selection.endDate).format('YYYY-MM-DD');

      this.setState({
        selectionRange: {
          ...state.selectionRange,
          startDate: dayjs(ranges.selection.startDate).toDate(),
          endDate: dayjs(ranges.selection.endDate).toDate(),
        },
      });

      const period = {
        datePreset: '',
        start: dayjs(ranges.selection.startDate).toDate(),
        end: dayjs(ranges.selection.endDate).toDate(),
        params: `since=${dayjs(ranges.selection.startDate).format('YYYY-MM-DD')}&until=${dayjs(
          ranges.selection.endDate
        ).format('YYYY-MM-DD')}`,
      };

      if (ranges.selection.isCustomOption) {
        period.isCustomOption = true;
      }

      if (
        startSelectionDate === defineds.startOfToday &&
        endSelectionDate === defineds.endOfToday
      ) {
        period.datePreset = 'TODAY';
        period.params = 'date_preset=today';
      } else if (
        startSelectionDate === defineds.startOfYesterday &&
        endSelectionDate === defineds.endOfYesterday
      ) {
        period.datePreset = 'YESTERDAY';
        period.params = 'date_preset=yesterday';
      } else if (
        startSelectionDate === defineds.startOfWeek &&
        endSelectionDate === defineds.endOfToday
      ) {
        period.datePreset = 'LAST_7D';
        period.params = 'date_preset=last_7d';
      } else if (
        startSelectionDate === defineds.startOfLastMonth &&
        endSelectionDate === defineds.endOfLastMonth
      ) {
        period.datePreset = 'LAST_MONTH';
        period.params = 'date_preset=last_month';
      } else if (
        startSelectionDate === defineds.startOfMonth &&
        endSelectionDate === defineds.endOfToday &&
        !period.isCustomOption
      ) {
        period.datePreset = 'THIS_MONTH';
        period.params = 'date_preset=this_month';
      } else if (
        startSelectionDate === defineds.startOfYear &&
        endSelectionDate === defineds.endOfToday
      ) {
        period.datePreset = 'THIS_YEAR';
        period.params = 'date_preset=this_year';
      } else if (startSelectionDate === startCustom && endSelectionDate === endCustom) {
        period.params = `since=${startCustom}&until=${endCustom}`;
      }

      handleSelectButtonCalendar(period);

      if (
        (!!period.datePreset && typeof ranges.selection.startDate === 'string') ||
        period.params === `since=${startCustom}&until=${endCustom}`
      ) {
        setTimeout(() => {
          saveDateRange(period);
        }, 1);
      }
    } else if (ranges.range1) {
      const startRangeOneDate = dayjs(ranges.range1.startDate).format('YYYY-MM-DD');
      const endRangeOneDate = dayjs(ranges.range1.endDate).format('YYYY-MM-DD');

      this.setState({
        selectionRange: {
          ...state.selectionRange,
          startDate: dayjs(ranges.range1.startDate).toDate(),
          endDate: dayjs(ranges.range1.endDate).toDate(),
        },
      });

      const period = {
        datePreset: '',
        start: dayjs(ranges.range1.startDate).toDate(),
        end: dayjs(ranges.range1.endDate).toDate(),
        params: `since=${dayjs(ranges.range1.startDate).format('YYYY-MM-DD')}&until=${dayjs(
          ranges.range1.endDate
        ).format('YYYY-MM-DD')}`,
      };

      if (ranges.selection.isCustomOption) {
        period.isCustomOption = true;
      }

      if (startRangeOneDate === defineds.startOfToday && endRangeOneDate === defineds.endOfToday) {
        period.datePreset = 'TODAY';
        period.params = 'date_preset=today';
      } else if (
        startRangeOneDate === defineds.startOfYesterday &&
        endRangeOneDate === defineds.endOfYesterday
      ) {
        period.datePreset = 'YESTERDAY';
        period.params = 'date_preset=yesterday';
      } else if (
        startRangeOneDate === defineds.startOfWeek &&
        endRangeOneDate === defineds.endOfToday
      ) {
        period.datePreset = 'LAST_7D';
        period.params = 'date_preset=last_7d';
      } else if (
        startRangeOneDate === defineds.startOfLastMonth &&
        endRangeOneDate === defineds.endOfLastMonth
      ) {
        period.datePreset = 'LAST_MONTH';
        period.params = 'date_preset=last_month';
      } else if (
        startRangeOneDate === defineds.startOfMonth &&
        endRangeOneDate === defineds.endOfToday &&
        !period.isCustomOption
      ) {
        period.datePreset = 'THIS_MONTH';
        period.params = 'date_preset=this_month';
      } else if (
        startRangeOneDate === defineds.startOfYear &&
        endRangeOneDate === defineds.endOfToday
      ) {
        period.datePreset = 'THIS_YEAR';
        period.params = 'date_preset=this_year';
      } else if (startRangeOneDate === startCustom && endRangeOneDate === endCustom) {
        period.params = `since=${startCustom}&until=${endCustom}`;
      }

      handleSelectButtonCalendar(period);
    }
  };

  onResize = (e) => {
    this.setMonth(e);
  };

  setMonth(size) {
    let countMonth = 1;
    let sizeScreen = 'big;';

    if (size >= 900) {
      countMonth = 2;
    }
    if (size < 550) {
      sizeScreen = 'small';
    }
    this.setState({
      countMonth,
      sizeScreen,
    });
  }

  render() {
    const {
      state,
      props: { ranges, hideStaticRanges, hideDateDisplay, minDate, maxDate, children },
    } = this;

    return (
      <ReactResizeDetector handleWidth onResize={this.onResize}>
        <S.SizeModal sizeScreen={state.sizeScreen}>
          <S.WidthModal hideStaticRanges={hideStaticRanges}>
            <DateRangePicker
              ranges={ranges || [state.selectionRange]}
              staticRanges={this.setStaticRanges()}
              inputRanges={this.setStaticInputRanges()}
              onChange={this.handleSelect}
              months={state.countMonth}
              direction="horizontal"
              locale={state.locale}
              minDate={minDate}
              maxDate={maxDate || new Date()}
              id="customDateRange"
              showDateDisplay={!hideDateDisplay}
            />
            {children}
          </S.WidthModal>
        </S.SizeModal>
      </ReactResizeDetector>
    );
  }
}

function mapStateToProps(state) {
  return {
    genericReducer: state.genericReducer,
  };
}

export default withRouter(connect(mapStateToProps)(translate('CustomDateRange')(CustomDateRange)));
